import SearchInput from '@/components/SearchInputTwo'
import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import BlockTitle from '@/components/BockTitle'
import BlockCard from './components/blockCard'
import DistrictTreasury from './components/districtTreasury'
import { getRegionDetail } from '@/api/region/index'
import { AddressInfo, RegionDetailData } from '@/api/region/types'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import StakingTrendData from './components/stakingTrendData'
import { useTranslation } from 'react-i18next'
import { formatValue, ugagToGag, ugeaToGea2 } from '@/utils/number'
import PledgeTrendChart from './components/PledgeTrendChart'

export interface AddressInfoItemFromat {
  address: string
  value: {
    value: string
    sigin: string
  }
  valueGag?: {
    value: string
    sigin: string
  }
}

const CountryRegionDetails: React.FC = () => {
  const params = useParams()
  const { t } = useTranslation()
  const [title, setTitle] = useState<string>('')
  const [regionDetail, setRegionDetail] = useState<RegionDetailData | null>(null)

  const initialAddressInfoItemFromat: AddressInfoItemFromat = {
    address: '',
    value: {
      value: '',
      sigin: '',
    },
  }
  // treasury 国家/区金库地址
  const [treasury, setTreasury] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // delegate 国家/区质押地址
  const [delegate, setDelegate] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // 国家/区 AGS 收益地址
  const [interest, setInterest] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // 国家/区管理地址
  const [operator, setOperator] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // 国家/区置换地址
  const [swap_pool, setSwap_pool] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // 国家/区 KYC 奖励发放地址
  const [kyc_vault, setKyc_vault] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // 国家/区 KYC 邀请奖励发放地址
  const [kyc_invite, setKyc_invite] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)
  // 国家/区 GasFee 地址
  const [gas_fee, setGas_fee] = useState<AddressInfoItemFromat>(initialAddressInfoItemFromat)

  const [govAddress, setGovAddress] = useState<AddressInfoItemFromat[]>([])

  /**
   * 获取地址信息
   * @param key
   * @param addressInfo
   * @returns
   */
  const getValueForFieldAddressInfo = (
    key: string,
    addressInfo: AddressInfo[],
  ): AddressInfoItemFromat => {
    const item = addressInfo.find((item) => item.name === key)
    if (!item) {
      return {
        address: '-',
        value: {
          value: '-',
          sigin: '',
        },
        valueGag: {
          value: '-',
          sigin: '',
        },
      }
    }

    if (key === 'interest') {
      return {
        address: formatValue(item.address),
        value: ugeaToGea2(item.ugeaAmount || 0, false, 8),
        valueGag: ugagToGag(item.ugeaAmount || 0, false, 8),
      }
    }
    return {
      address: formatValue(item.address),
      value: ugeaToGea2(item.ugeaAmount || 0, false, 8),
    }
  }
  const getRegionDetailFn = async () => {
    const res = await getRegionDetail({ region_id: params.dynamic as string })
    if (res) {
      setRegionDetail(res)
      const treasury = getValueForFieldAddressInfo('treasury', res.addressInfo)
      setTreasury(treasury as AddressInfoItemFromat)
      const delegate = getValueForFieldAddressInfo('delegate', res.addressInfo)
      setDelegate(delegate as AddressInfoItemFromat)
      const interest = getValueForFieldAddressInfo('interest', res.addressInfo)
      setInterest(interest as AddressInfoItemFromat)
      const operator = getValueForFieldAddressInfo('operator', res.addressInfo)
      setOperator(operator as AddressInfoItemFromat)
      const swap_pool = getValueForFieldAddressInfo('swap_pool', res.addressInfo)
      setSwap_pool(swap_pool as AddressInfoItemFromat)
      const kyc_vault = getValueForFieldAddressInfo('kyc_vault', res.addressInfo)
      setKyc_vault(kyc_vault as AddressInfoItemFromat)
      const kyc_invite = getValueForFieldAddressInfo('kyc_invite', res.addressInfo)
      setKyc_invite(kyc_invite as AddressInfoItemFromat)
      const gas_fee = getValueForFieldAddressInfo('gas_fee', res.addressInfo)
      setGas_fee(gas_fee as AddressInfoItemFromat)

      const govAddressArr = res.govAddress.map((item) => {
        const value = getValueForFieldAddressInfo(item.name, res.govAddress)
        return value
      })
      setGovAddress(govAddressArr)
    }
  }

  useEffect(() => {
    if (params.dynamic) {
      if (params.dynamic === 'global_village') {
        setTitle(t('explorer_266'))
      } else {
        setTitle(params.dynamic.toUpperCase() + '-Zone')
      }
      getRegionDetailFn()
    }
  }, [])
  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        {/* 区域详情 */}
        <Title title={t('explorer_56')} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      <div>
        <BlockTitle title={title}></BlockTitle>
        <BlockCard geaTotal={treasury.value} regionDetail={regionDetail} />
      </div>
      <div>
        {/* 国家/区金库地址 */}
        <BlockTitle title={t('explorer_59')}></BlockTitle>
        <div className="district_treasury_list">
          {/* 国家/区金库地址 */}
          <DistrictTreasury
            address={treasury?.address}
            cardInfo={treasury.value}
            tipkey="explorer_237_treasury"
            title={t('explorer_59')}
          ></DistrictTreasury>
          {/* 国家/区质押地址 */}
          <DistrictTreasury
            address={delegate?.address}
            cardInfo={delegate.value}
            tipkey="explorer_238_delegate"
            title={t('explorer_60')}
          ></DistrictTreasury>
          {/* 国家/区 AGS 收益地址 就是 区周期质押利息地址  */}
          <DistrictTreasury
            address={interest?.address}
            cardInfo={interest.value}
            tipkey="explorer_239_interest"
            title={t('explorer_61')}
          ></DistrictTreasury>
          {/* 国家/区管理地址 */}
          <DistrictTreasury
            address={operator?.address}
            cardInfo={operator.value}
            tipkey="explorer_240_operator"
            title={t('explorer_62')}
          ></DistrictTreasury>
          {/* 国家/区置换地址 */}
          <DistrictTreasury
            address={swap_pool?.address}
            cardInfo={swap_pool.value}
            tipkey="explorer_241_swap_pool"
            title={t('explorer_63')}
          ></DistrictTreasury>
          {/* 国家/区 KYC 奖励发放地址 */}
          <DistrictTreasury
            address={kyc_vault?.address}
            cardInfo={kyc_vault.value}
            tipkey="explorer_242_kyc_vault"
            title={t('explorer_64')}
          ></DistrictTreasury>
          {/* 国家/区 KYC 邀请奖励发放地址 */}
          <DistrictTreasury
            address={kyc_invite?.address}
            cardInfo={kyc_invite.value}
            tipkey="explorer_243_kyc_invite"
            title={t('explorer_65')}
          ></DistrictTreasury>
          {/* 国家/区 GasFee 地址 */}
          <DistrictTreasury
            address={gas_fee?.address}
            cardInfo={gas_fee.value}
            tipkey="explorer_244_gas_fee"
            title={t('explorer_66')}
          ></DistrictTreasury>
          {/* 国家/区治理地址 */}
          {govAddress.map((item, index) => {
            return (
              <DistrictTreasury
                key={index}
                address={item.address}
                cardInfo={item.value}
                tipkey={'explorer_245_gov'}
                title={`${t('explorer_67')}_${index + 1}`}
              ></DistrictTreasury>
            )
          })}
          {/* 暂时不做 */}
          {/* <DistrictTreasury title="区/灵活锁仓治理奖地址"></DistrictTreasury> */}
        </div>
      </div>
      <div className="chart_wrap">
        {/* <div className={styles.staking_trend_data}>
          <BlockTitle title={t('explorer_68')}></BlockTitle>
          <StakingTrendData regionDetail={regionDetail} interest={interest}></StakingTrendData>
        </div> */}
        {/* <div className={styles.pledge_trend_chart}>
          <BlockTitle title={t('explorer_73')}></BlockTitle>
          <PledgeTrendChart></PledgeTrendChart>
        </div> */}
      </div>
    </div>
  )
}

export default CountryRegionDetails
